import "./index.module-f2d54a83.css";
const n = "_input_balloon_wrap_kuunn_1", o = "_ballon_wrap_kuunn_11", _ = "_ballon_icon_kuunn_15", l = "_dark_kuunn_24", a = "_balloon_overlay_kuunn_27", t = "_balloon_content_kuunn_27", b = "_balloon_content_dark_kuunn_30", c = {
  input_balloon_wrap: n,
  ballon_wrap: o,
  ballon_icon: _,
  dark: l,
  balloon_overlay: a,
  balloon_content: t,
  balloon_content_dark: b
};
export {
  c as s
};
//# sourceMappingURL=index.module-cae6c400.js.map
